module.exports = __webpack_public_path__ + "r-v3/img/translation_JA.53988fa3.png";